var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-not-login",
    transform: "translate(-1222.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(58.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1164.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEB300",
    opacity: 0.5,
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    rx: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,19 C16.794,19 15,17.206 15,15 C15,12.794 16.794,11 19,11 C21.206,11 23,12.794 23,15 C23,17.206 21.206,19 19,19 M22.758,19.673 C24.124,18.574 25,16.89 25,15 C25,11.686 22.314,9 19,9 C15.686,9 13,11.686 13,15 C13,16.89 13.876,18.574 15.242,19.673 C11.583,21.048 9,24.445 9,29 L11,29 C11,24 14.589,21 19,21 C23.411,21 27,24 27,29 L29,29 C29,24.445 26.417,21.048 22.758,19.673",
    id: "profile-[#1335]",
    fill: "#9E0201"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.880e5fba08cbf0d482d6041a1c044192.svg";
export { ForwardRef as ReactComponent };